import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, Link } from "react-router-dom";
import { setUser } from '../../features/auth/authSlice';
import authService from '../../services/authService';
import { jwtDecode } from 'jwt-decode';
import { getUserProfile } from '../../services/api';
import { FiLogOut } from "react-icons/fi";

import "../Nav/_Navbar.scss";

const DEFAULT_PROFILE_IMAGE = '/profilpic.webp';

function Navbar() {
    const user = useSelector(state => state.auth.user);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [menuOpen, setMenuOpen] = useState(false);
    const [profileData, setProfileData] = useState({
        username: '',
        email: '',
        firstName: '',
        lastName: '',
        profilePhoto: DEFAULT_PROFILE_IMAGE,
        birthday: '',
        bio: ''
    });

    useEffect(() => {
        if (user && user.token) {
            const userId = jwtDecode(user.token).user.id;
            fetchProfileData(userId);
        } else {
            setProfileData({
                username: '',
                email: '',
                firstName: '',
                lastName: '',
                profilePhoto: DEFAULT_PROFILE_IMAGE,
                birthday: '',
                bio: ''
            });
        }
    }, [user]);

    const fetchProfileData = async (userId) => {
        try {
            const data = await getUserProfile(userId);
            setProfileData({ ...data, profilePhoto: data.profilePhoto || DEFAULT_PROFILE_IMAGE });
        } catch (err) {
            console.error('Failed to fetch profile data:', err);
        }
    };

    const handleLogout = () => {
        authService.logout();
        dispatch(setUser(null));
        navigate('/login');
    };

    const closeMenu = () => {
        setMenuOpen(false);
    };

    return (
        <nav className="navbar">
            <div className="nav-left ">
                <div className="menu-icon" onClick={() => setMenuOpen(!menuOpen)}>
                    ☰
                </div>
            </div>
            <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
                {user ? (
                    <>
                        <li><Link to="/home"onClick={closeMenu}>Home</Link></li>
                        <li><Link to="/bookshelf"onClick={closeMenu}>Bookshelf</Link></li>
                        <li><Link to={`/profile/${user?.user?.id}`}onClick={closeMenu}>Profile</Link></li>
                        <li><Link to="/news"onClick={closeMenu}>News</Link></li>
                        {user && <img src={`${profileData.profilePhoto}?${new Date().getTime()}`} alt="Profile" className="nav-profile-img" />}

                        <li className="nav-profile-container">
                            <img src={`${profileData.profilePhoto}?${new Date().getTime()}`} alt="Profile" className="nav-profile-img-desktop" />
                        </li>
                        <li><button onClick={handleLogout} className="nav-logout-btn"><FiLogOut /></button></li>
                    </>
                ) : (
                    <>
                        <li><Link to="/"onClick={closeMenu}>Home</Link></li>
                        <li><Link to="/news"onClick={closeMenu}>News</Link></li>
                        <li><Link to="/login"onClick={closeMenu}>Login</Link></li>
                    </>
                )}
            </ul>
        </nav>
    );
}

export default Navbar;